// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"loader_ellipsis__qrV_A","ellipsis1":"loader_ellipsis1__T1B4R","ellipsis2":"loader_ellipsis2__uLExP","ellipsis3":"loader_ellipsis3__4aAT9"};